import React from 'react';
import { Checkbox, MousePositionedTooltip } from '@keen.io/ui-core';
import { CellContainer, CellContent } from '../../body-cell';
export var Cell = function (_a) {
    var width = _a.width, cell = _a.cell, row = _a.row, onCellClick = _a.onCellClick, editMode = _a.editMode;
    var key = cell.getCellProps().key;
    var checked = row.getToggleRowSelectedProps().checked;
    return (React.createElement(CellContainer, { isDisabled: editMode, "data-testid": "table-selection-column-cell", key: key, onClick: function (e) { return onCellClick(e); } },
        React.createElement(MousePositionedTooltip, { isActive: editMode, tooltipPinPlacement: "bottom-right", renderContent: function () {
                return 'Row selection is not possible during value formatting.';
            } },
            React.createElement(CellContent, { textAlignment: "center", width: width },
                React.createElement(Checkbox, { id: key.toString(), display: "inline-flex", type: "secondary", checked: checked })))));
};
